module.exports = __webpack_public_path__ + "static/media/error-graphic.e63b759c.svg";